import React from 'react';
import Navbar from '../components/storefront/Navbar';
import Hero from '../components/storefront/Hero';
import Collection from '../components/storefront/Collection';
import Features from '../components/storefront/Features';
import Experience from '../components/storefront/Experience';
import Process from '../components/storefront/Process';
import Lifestyle from '../components/storefront/Lifestyle';
import Testimonials from '../components/storefront/Testimonials';
import FinalCTA from '../components/storefront/FinalCTA';
import Footer from '../components/storefront/Footer';

const Storefront = () => {
  return (
    <div className="relative bg-brand-sand">
      <Navbar />
      <main>
        <Hero />
        <Collection />
        <Lifestyle />
        <Experience />
        <Process />
        <Features />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Storefront;